import { denormalize } from "normalizr";

import { paymentProfile } from "../../../api/schema";

export default state => {
  try {
    const items = state.groups.invitedCarriers.ids;

    const denormalized = denormalize(
      { items },
      { items: [paymentProfile] },
      state.entities
    );
    return denormalized.items || [];
  } catch (err) {
    return [];
  }
};
